import React, { useState, useEffect } from 'react';

import { SingleInput, SingleText } from '../../Res/BaseInput';
import { RespCustomerContract_ProjectContact } from '../../../../item/ItemCustomerContract';

export function ItemAProjectContact({ item, action, isEdit = true }) {
  const [AProjectContact, setAProjectContact] = useState("")
  const [department, setDepartment] = useState("")
  const [jobTitle, setJobTitle] = useState("")
  const [name, setName] = useState("")
  const [tel, setTel] = useState("")

  useEffect(() => {
    if (item !== undefined && AProjectContact !== item) {
      setAProjectContact(item)
      setDepartment(item.department)
      setJobTitle(item.jobTitle)
      setName(item.name)
      setTel(item.tel)
    }
  }, [item])

  useEffect(() => {
    if (action !== undefined) {
      var mRespCustomerContract_ProjectContact = new RespCustomerContract_ProjectContact({
        department,
        jobTitle,
        name,
        tel,
      })
      action(mRespCustomerContract_ProjectContact)
    }
  }, [department, jobTitle, name, tel, action])


  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>甲方專案聯絡人</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleInput title={"部門"} val={department} action={setDepartment} placeholder={"管理課"} />
            : <SingleText title={"部門"} val={department} />
          }
          {isEdit ?
            <SingleInput title={"職稱"} val={jobTitle} action={setJobTitle} placeholder={"課長"} />
            : <SingleText title={"職稱"} val={jobTitle} />
          }
          {isEdit ?
            <SingleInput title={"姓名"} val={name} action={setName} placeholder={"王大同"} />
            : <SingleText title={"姓名"} val={name} />
          }
          {isEdit ?
            <SingleInput title={"電話"} val={tel} action={setTel} placeholder={"0223921100"} />
            : <SingleText title={"電話"} val={tel} />
          }
        </div>
      </div>
    </>
  )
}